module.exports = __webpack_public_path__ + "img/three3Red.d48a646c.jpg";